window.EVASuit = window.EVASuit || {};
window.EVASuit.Behaviors = window.EVASuit.Behaviors || {};

window.EVASuit.Behaviors.Focus = (function() {
    "use strict";

    var module = {}, element_states = new WeakMap();

    /**
     * Make an entire element and its children unfocusable.
     * 
     * Tabindexes will be set to -1 on all elements. Prior existing indexes
     * will be retained and restored when the element is made focusable again.
     * 
     * @param {Element} elem The DOM element to exclude from focus.
     */
    function make_element_unfocusable(elem) {
        var i;

        if (elem.attributes.tabIndex !== undefined && (!element_states.has(elem) || elem.tabIndex !== -1)) {
            element_states.set(elem, elem.tabIndex);
        }

        elem.tabIndex = -1;

        for (i = 0; i < elem.children.length; i += 1) {
            if (elem.children[i]) {
                make_element_unfocusable(elem.children[i]);
            }
        }
    }

    /**
     * Make an entire element and its children focusable.
     * 
     * This presumes that the element was made unfocusable prior. If it hasn't,
     * no change will be made to the element.
     * 
     * @param {Element} elem The DOM element to include back into focus.
     */
    function make_element_focusable(elem) {
        var i;

        if (element_states.has(elem)) {
            elem.tabIndex = element_states.get(elem);
        } else {
            delete elem.tabIndex;
            delete elem.removeAttribute("tabIndex");
        }

        for (i = 0; i < elem.children.length; i += 1) {
            if (elem.children[i]) {
                make_element_focusable(elem.children[i]);
            }
        }
    }

    module.make_element_focusable = make_element_focusable;
    module.make_element_unfocusable = make_element_unfocusable;

    return module;
}());